import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { PageHeader, Loader, StatCard } from "@/components/ui-kit";
import { StatusBadge } from "@/components/StatusBadge";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Bike, Route, Warehouse, CalendarDays, Coins, TrendingUp, Wallet, UserPlus, Users2, Package, CreditCard, AlertTriangle, Scale, Receipt, ClipboardList } from "lucide-react";
import { money } from "@/lib/vi";

export default function ViDashboard() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/itinerant/dashboard").then((r) => setD(r.data)); }, []);
  if (!d) return <Loader />;
  const cards = [
    ["Tricycles actifs", d.tricycles_actifs, Bike, "blue"], ["En tournée", d.en_tournee, Route, "emerald"], ["Au dépôt", d.au_depot, Warehouse, "slate"],
    ["Tournées du jour", d.tournees_jour, CalendarDays, "blue"], ["CA du jour", money(d.ca_jour), Coins, "emerald"], ["CA du mois", money(d.ca_mois), TrendingUp, "emerald"],
    ["Encaissements du jour", money(d.encaissements_jour), Wallet, "blue"], ["Commandes en attente", d.commandes_attente, ClipboardList, "slate"],
    ["Nouveaux prospects", d.nouveaux_prospects, UserPlus, "amber"], ["Nouveaux clients", d.nouveaux_clients, Users2, "emerald"],
    ["Stock mobile total", money(d.stock_mobile), Package, "blue"], ["Crédits en cours", money(d.credits_en_cours), CreditCard, "amber"],
    ["Écarts de stock", d.ecarts_stock, AlertTriangle, "rose"], ["Écarts de caisse", money(d.ecarts_caisse), Scale, "rose"], ["Dépenses du mois", money(d.depenses_mois), Receipt, "amber"],
  ];
  return (
    <div data-testid="vi-dashboard">
      <PageHeader title="Vente itinérante" subtitle="Pilotage des tricycles, tournées et ventes terrain" />
      {d.alertes.length > 0 && (
        <div className="mb-4 rounded-xl border border-amber-200 bg-amber-50 p-3 text-sm" data-testid="vi-alerts">
          {d.alertes.map((a, i) => <p key={i} className="text-amber-800"><AlertTriangle className="inline h-4 w-4 mr-1" />{a.tricycle} — {a.type} {a.niveau === "expiré" ? "expirée" : "à échéance"} le {a.date}</p>)}
        </div>
      )}
      <div className="grid grid-cols-2 lg:grid-cols-5 gap-3 mb-6">{cards.map(([l, v, I, a]) => <StatCard key={l} label={l} value={v} icon={I} accent={a} />)}</div>
      <div className="rounded-xl border bg-white overflow-hidden">
        <p className="px-4 py-3 font-head font-semibold text-sm border-b">Tricycles</p>
        <div className="overflow-x-auto scrollbar-thin">
          <Table>
            <TableHeader><TableRow className="bg-slate-50">{["Code", "Immatriculation", "Conducteur-vendeur", "Circuit", "Statut", "CA du jour", "Stock embarqué", "Encaissement", "Départ", "Retour"].map((h) => <TableHead key={h}>{h}</TableHead>)}</TableRow></TableHeader>
            <TableBody>
              {d.tricycles.map((t) => (
                <TableRow key={t.id} data-testid={`vi-dash-tri-${t.code}`}>
                  <TableCell className="font-mono text-xs">{t.tournee_id ? <Link className="text-brand-700 hover:underline" to={`/vi/tournees/${t.tournee_id}`}>{t.code}</Link> : t.code}</TableCell>
                  <TableCell>{t.immatriculation}</TableCell><TableCell>{t.conducteur || "—"}</TableCell><TableCell>{t.circuit || "—"}</TableCell>
                  <TableCell><StatusBadge value={t.statut} /></TableCell><TableCell className="font-mono text-xs">{money(t.ca_jour)}</TableCell>
                  <TableCell className="font-mono text-xs">{money(t.stock)}</TableCell><TableCell className="font-mono text-xs">{money(t.encaissement)}</TableCell>
                  <TableCell>{t.depart || "—"}</TableCell><TableCell>{t.retour || "—"}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </div>
    </div>
  );
}
